export default function setCookie(name, value, days) {
	let expires = '';

	if (days) {
		let date = new Date()
		date.setTime(date.getTime() + (days*24*60*60*1000))
		expires = '; expires=' + date.toUTCString()
	}

	document.cookie = name + '=' + (value || '')  + expires + '; path=/'
}

export function setMinuteCookie(name, value, minutes) {
	let expires = '';

	if (minutes) {
		let date = new Date()

		date.setTime(date.getTime() + (minutes*60*1000))
		expires = `; expires=${date.toUTCString()}`
	}

	document.cookie = name + '=' + (value || '')  + expires + '; path=/'
}


// WEBPACK FOOTER //
// ./src/utilities/session/setCookie.js